module.exports = {
	"ha": "bc",
	"id": 5.3,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q3–2018 Q2",
		"lastYear": "2018",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by Age Category, Year Ending 2018 Q2 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -130,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 67.96875,
						"dataLabels": {
							"enabled": true,
							"format": "348",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 57.421875,
						"dataLabels": {
							"enabled": true,
							"format": "294",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 53.515625,
						"dataLabels": {
							"enabled": true,
							"format": "274",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 45.3125,
						"dataLabels": {
							"enabled": true,
							"format": "232",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 38.0859375,
						"dataLabels": {
							"enabled": true,
							"format": "195",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 92.76119402985074,
						"dataLabels": {
							"enabled": true,
							"format": "1243",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 77.38805970149254,
						"dataLabels": {
							"enabled": true,
							"format": "1037",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 71.41791044776119,
						"dataLabels": {
							"enabled": true,
							"format": "957",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 63.13432835820896,
						"dataLabels": {
							"enabled": true,
							"format": "846",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 52.38805970149254,
						"dataLabels": {
							"enabled": true,
							"format": "702",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 93.15701091519732,
						"dataLabels": {
							"enabled": true,
							"format": "2219",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 75.65071368597816,
						"dataLabels": {
							"enabled": true,
							"format": "1802",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 70.44500419815282,
						"dataLabels": {
							"enabled": true,
							"format": "1678",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 64.02183039462636,
						"dataLabels": {
							"enabled": true,
							"format": "1525",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 51.7632241813602,
						"dataLabels": {
							"enabled": true,
							"format": "1233",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 93.61838932647484,
						"dataLabels": {
							"enabled": true,
							"format": "5824",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 77.43128114451054,
						"dataLabels": {
							"enabled": true,
							"format": "4817",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 73.21973959170552,
						"dataLabels": {
							"enabled": true,
							"format": "4555",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 69.5708085516798,
						"dataLabels": {
							"enabled": true,
							"format": "4328",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 59.25092428869957,
						"dataLabels": {
							"enabled": true,
							"format": "3686",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -32.03125,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -15.517241379310342,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.802721088435371,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -15.328467153284675,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -15.94827586206896,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -7.2388059701492535,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -16.572807723250204,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.714561234329798,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.598746081504707,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -17.021276595744684,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -6.842989084802687,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -18.792248760703025,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.881243063263042,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.117997616209772,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -19.14754098360656,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -6.381610673525162,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -17.290521978021978,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.439069960556364,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.983534577387482,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.83364140480592,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=512"
			},
			{
				"x": 9,
				"text": "30–39<br>n=1340"
			},
			{
				"x": 15,
				"text": "40–49<br>n=2382"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=6221"
			}
		],
		"dataTable": {
			"< 30": [
				512,
				348,
				294,
				274,
				232,
				195
			],
			"30–39": [
				1340,
				1243,
				1037,
				957,
				846,
				702
			],
			"40–49": [
				2382,
				2219,
				1802,
				1678,
				1525,
				1233
			],
			"≥ 50": [
				6221,
				5824,
				4817,
				4555,
				4328,
				3686
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Projects\\cfenet.ubc.ca-qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_3.json
// module id = 167
// module chunks = 0